import { skipToken, useQuery } from '@tanstack/react-query';
import apiProxyClient from '@libs/api-proxy-client';

export function useDiscountDetailsQuery(promotionKey?: string) {
    return useQuery({
        queryKey: ['discount-details', promotionKey],
        queryFn: promotionKey
            ? () => apiProxyClient.discounts.getDiscountDetails(promotionKey)
            : skipToken,
        staleTime: 60 * 60 * 1000, // 1hr
    });
}
